// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { MenuTokens } from './type';

const menuTokens: MenuTokens = {
  menuFontSize: '14/regular',
  menuFontColor: 'Neutral-text-5',
  menuIconColor: 'Neutral-text-4',
  menuItemBackgroundColor: 'Neutral-fill-1',
  menuItemFontColor: 'Neutral-text-5',
  menuItemHoverBackgroundColor: 'Neutral-fill-2',
  menuItemHoverFontColor: 'Neutral-text-5',
  menuItemActiveBackgroundColor: 'Brand-1',
  menuItemActiveHoverBackgroundColor: 'Brand-2',
  menuItemActiveFontColor: 'Brand-6',
  menuItemDisabledBackgroundColor: 'Neutral-fill-1',
  menuItemDisabledFontColor: 'Neutral-text-2',
  menuTitlePaddingX: '16px',
  menuTitlePaddingY: '9px',
  menuExpandWidth: '46px',
  menuExpandSize: '14px',
  menuExpandHoverBackgroundColor: 'Neutral-fill-3',
  menuChildrenBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  menuDarkFontColor: 'Neutral-text-1',
  menuDarkItemBackgroundColor: 'Neutral-fill-10',
  menuDarkItemFontColor: 'Neutral-text-1',
  menuDarkItemHoverBackgroundColor: 'Brand-9',
  menuDarkItemHoverFontColor: 'Neutral-text-1',
  menuDarkItemActiveBackgroundColor: 'Brand-6',
  menuDarkItemActiveFontColor: 'Neutral-text-1',
  menuDarkItemOpenBackgroundColor: 'Neutral-fill-9',
  menuDarkItemOpenFontColor: 'Neutral-text-1',
  menuDarkItemDisabledBackgroundColor: 'Neutral-fill-10',
  menuDarkItemDisabledFontColor: 'Neutral-text-4',
};

export default menuTokens;
